import React, { Component } from 'react';
import './HeaderTool.css';
import { NavLink, Link } from 'react-router-dom';
import profile from '../../../../image/personlg.svg'
class HeaderTool extends Component {
    constructor(){
        super();

        this.state = {
            block: false
        }
    }
    changeColor(){
        this.setState({block: !this.state.block})
     }
     Logout=()=>{
        localStorage.removeItem("KaynuserName")
        localStorage.removeItem("userToken")
        localStorage.removeItem("userTokentConfirmData")
        window.location.replace("/AR/Signin")

     }
    render() {
        const Name = localStorage.getItem("KaynuserName")
        const url =window.location.pathname.split('/').slice(2).toString().replace(',', '/')
        return (
            <div className="HeaderTool text-left px-3">
                <ul className="nav text-center ">
                    <li className="nav-item dropdown select  ">
                        <a className="nav-link text-right clearfix" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                            <img className="mx-3 imagprofile" src={profile} alt="profile" />
                        </a>
                        <div className="dropdown-menu m-0 p-3 text-right">
                            <p className="dropdown-item p-0">اهلا, {Name}</p><hr />
                            <Link className="dropdown-item" to="/AR/Profile">الصفحة الشخصيه</Link>
                            <Link className="dropdown-item" to={"/"+url}>EN</Link>
                            <p className="dropdown-item" onClick={this.Logout}>تسجيل خروج</p>
                        </div>
                    </li>
                </ul>
               
                  <div className={"sidebarAR d-lg-none d-md-none d-sm-block  shadow "+( this.state.block ? "sidebarblock" : "sidebarnone")} >
                    <ul className="navbar-nav sticky-top text-uppercase iconsnavclient">

                    
                    
                        <li className="nav-item ">
                            <NavLink to="/AR/NewOrder" className="iconnav "><div className="iconneworder mx-auto"></div><p className="fontsize15">طلب جديد</p></NavLink>
                        </li>                            

                        <li className="nav-item ">
                            <NavLink to="/AR/Orders" className="iconnav "><div className="iconorders  mx-auto">  </div><p className="fontsize15">الطلبات</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/MyClients" className="iconnav "><div className="iconclient  mx-auto"></div><p className="fontsize15">عملائي</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/ClientAdderss" className="iconnav "><div className="iconaddressbook   mx-auto"></div><p className="fontsize15">العناوين</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/AR/Wallet" className="iconnav "><div className="iconwallet  mx-auto"></div><p className="fontsize15">المحفظه</p></NavLink>
                        </li>
                    </ul>
                </div>
                <button className=" d-lg-none d-md-none d-sm-block btn  fixed-top btnminuAR" onClick={this.changeColor.bind(this)}>&#9776;</button>

            </div>
        )
    }
}
export default HeaderTool;